<template>
  <div class="search-bar">
    <b-form onSubmit="return false;">
      <strong>
        <span class="title">Search Here</span>
      </strong>
      <b-form-input
        id="data-search"
        v-model="search"
        placeholder="Enter keyword"
        debounce="500">
      </b-form-input>
    </b-form>
  </div>
</template>
<script>
import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import Fuse from 'fuse.js';

const fuseOptions = {
  shouldSort: true,
  tokenize: true,
  includeScore: true,
  threshold: 0.09,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 3,
  keys: [
    'site.site_area',
    'site.site_name',
    'parameters.parameter_name',
    'parameters.reference_designator',
    'infrastructure.infrastructure_name',
    'instrument.formal_name',
    'instrument.instrument_name',
  ],
};

export default {
  data() {
    return {
      search: '',
      fuse: null,
    };
  },
  computed: mapState({
    catalog: (state) => state.instrumentsCatalog,
    results: (state) => state.filteredCatalog,
    sites: (state) => state.sites,
  }),
  methods: {
    initFuse() {
      this.fuse = new Fuse(this.catalog, fuseOptions);
    },
    ...mapMutations([
      'updateSearchResult', // map `this.updateSearchResult(val)` to `this.$store.commit('updateSearchResult')`
    ]),
    ...mapActions([
      'setSelectedInstrument',
    ]),
  },
  mounted() {
    this.initFuse();
  },
  watch: {
    search(newVal) {
      let sresults = [];
      let selectedInstNames = [];
      if (newVal !== '') {
        const searchResults = this.fuse.search(newVal);
        const dataRefs = searchResults.map((val) => val.item);
        const instruments = _.uniqBy(dataRefs, 'instrument.reference_designator');
        sresults = instruments.map((val) => val.instrument);
        selectedInstNames = _.uniq(sresults.map((inst) => inst.instrument_name));
      }
      this.setSelectedInstrument({ selected: selectedInstNames });
      this.updateSearchResult(sresults);
    },
  },
};
</script>

<style lang="sass" scoped>
.title
  font-size: 1.3rem
</style>
